//#region src/post_add_upsell_type.ts
var PostAddUpsellType = /* @__PURE__ */ function(PostAddUpsellType) {
	PostAddUpsellType["Modifier"] = "modifier";
	PostAddUpsellType["Section"] = "section";
	return PostAddUpsellType;
}(PostAddUpsellType || {});
//#endregion
export { PostAddUpsellType };

//# sourceMappingURL=post_add_upsell_type.js.map